module.exports = __webpack_public_path__ + "media/cards/8-fe7382ed.png";